var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{font-family:Poppins,sans-serif}form{background-image:url(" + escape(require("./assets/images/bg-shorten-desktop.svg")) + ")}.bo3,form{background-color:#3b3054}.bo3{background-image:url(" + escape(require("./assets/images/bg-boost-desktop.svg")) + ")}p{color:#9e9aa7}.imgIcon{background-color:#35323e;border-radius:50%;padding:20px}#errorMsg{color:#f46262}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36d9cb4e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 16
// module chunks = 0